const maskToTypedDate = (value, hasSlashAtEnd) => {
    const formatted = value.replace(/\D+/g, '');
    let i = 0;
    if (formatted.length > 4) {
        return '##/##/####'.replace(/#/g, _ => formatted[i++] || '');
    }
    if (formatted.length > 2) {
        const label = '##/##'.replace(/#/g, _ => formatted[i++] || '');
        if (formatted.length === 4 && !hasSlashAtEnd) {
            return `${label}/`;
        }
        return label;
    }
    if (formatted.length === 2 && !hasSlashAtEnd) {
        return `${formatted}/`;
    }
    return formatted;
};

export { maskToTypedDate };
//# sourceMappingURL=maskToTypedDate.js.map
